import styled from 'styled-components';

export const TagWrapper = styled.div`
  height: 32px;
  padding: 6px 8px;
  border-radius: 6px;
  background-color: ${({ color }) => color};
`;

export const TagContent = styled.div`
  display: flex;
`;

export const TagText = styled.p`
  font-size: 12px;
  color: #fff;
  margin: 0;
`;

export const ExitButton = styled.button`
  margin-left: 12px;
  background-color: transparent;
`;
